import { format, parseISO } from 'date-fns'
export const UnassignedColumns = [
  {
    field: 'created_datetime',
    headerName: 'Created On',
    width: 175,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 180,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 250,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 180,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
]

export const AssignedColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned Date',
    width: 150,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 135,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'first_name',
    headerName: 'Assigned To',
    width: 180,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''} ${params.row.last_name || ''}`,
  },
]

export const QCCasesColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 140,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 140,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'first_name',
    headerName: 'Assigned To',
    width: 180,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''} ${params.row.last_name || ''}`,
  },
]

export const LMComplete = [
  {
    field: 'updated_datetime',
    headerName: 'Time of Release',
    width: 170,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.updated_datetime + ''), 'yyyy-MM-dd HH:mm:ss')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 190,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'first_name',
    headerName: 'Signature',
    width: 160,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''}, ${params.row.last_name || ''}`,
  },
  {
    field: 'outcome',
    headerName: 'Result',
    width: 145,
    headerClassName: 'super-app-theme--header',
  },
]

export const HolidayColumns = [
  {
    field: 'holiday_date',
    headerName: 'Date',
    width: 400,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'holiday_name',
    headerName: 'Holiday',
    width: 550,
    headerClassName: 'super-app-theme--header',
  },
]
